export const API_URL = import.meta.env.VITE_API_URL;
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_APP_RECAPTCHA_SITE_KEY;

// # Google Authentication Popup
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI_STAGING;
export const GOOGLE_SCOPES = import.meta.env.VITE_GOOGLE_SCOPES;
// console.log('🚀 ~ GOOGLE_CLIENT_ID:', { GOOGLE_CLIENT_ID, GOOGLE_REDIRECT_URI, GOOGLE_SCOPES });

// # Microsoft Authentication Popup
export const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID;
export const MICROSOFT_SCOPES = import.meta.env.VITE_MICROSOFT_SCOPES;
export const MICROSOFT_TENANT_ID = import.meta.env.VITE_MICROSOFT_TENANT_ID;
export const MICROSOFT_REDIRECT_URl = import.meta.env.VITE_MICROSOFT_REDIRECT_URl_STAGING;
// console.log('🚀 ~ MICROSOFT_SCOPES:', {
//   MICROSOFT_SCOPES,
//   MICROSOFT_TENANT_ID,
//   MICROSOFT_CLIENT_ID,
//   MICROSOFT_REDIRECT_URl,
// });
